import { NgModule } from '@angular/core';
import { CRUDService } from 'src/app/core/src/crud';
import { EClass } from 'src/app/model';
import { Subject, Observable } from 'rxjs';
import { IRequestEvent, EActionEvent } from './users.model';

@NgModule({
	imports: [],
	declarations: [],
	providers: []
})
export class UsersService extends CRUDService {
	c = EClass.USERS;

	userSubjectEvent: Subject<IRequestEvent> = new Subject();
	userEvent: Observable<IRequestEvent> = this.userSubjectEvent.asObservable()


	private _userNext(obj: IRequestEvent) {
		this.userSubjectEvent.next(obj);
	}
	getUserEvent(): Observable<IRequestEvent> {
		return this.userEvent
	}
	getName() {
		return this.find('data', { c: this.c, d: 25 })
			.subscribe(data => this._userNext({
				class: this.c,
				action: EActionEvent.FIND,
				data: data,
			}),
				e => console.error(e))
	}
	getAll() {
		return this.find('data', { c: this.c })
			.subscribe(
				data => this._userNext({
					class: this.c,
					action: EActionEvent.FIND,
					data: data,
				}),
				e => console.error(e))
	}
	getUser(id: string) {
		return this.get(id, 'data', { c: this.c })
			.subscribe(
				data => this._userNext({
					class: this.c,
					action: EActionEvent.GET,
					data: data,
				}),
				e => console.error(e))
	}
	createUser() {
		let user = {
			name: 'gaga'
		}
		return this.create('data', { c: this.c }, user);
	}
}
